module.exports = "/_next/static/images/icon-camera-5d664641812d0cecbead936b8866b0c0.svg";